module.exports = "/_next/static/images/constructionGlobe-281ede01d9db17d75fa6978d60425ac5.png.webp";